import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['toggleable']
  static values = { 
    open: Boolean,
    toggleableSelector: String ,
    initialOpen: Boolean
  }

  connect() {
    this.toggleClass = this.data.get('class') || 'hidden'
    if (this.hasInitialOpenValue && (this.initialOpenValue === false || this.initialOpenValue === 'false')) {
      this.openValue = false;
    }
  }

  toggle(event) {
    if (event.target.getAttribute('type') != 'checkbox') {
      event.preventDefault();
    }

    this.openValue = !this.openValue;
  }

  hide(event) {
    event.preventDefault();

    this.openValue = false;
  }

  show(event) {
    event.preventDefault();

    this.openValue = true;
  }

  openValueChanged() {
    if (!this.toggleClass) { return }

    // Use custom selector if provided, otherwise use default targets
    if (this.hasToggleableSelectorValue) {
      const customTargets = this.element.querySelectorAll(this.toggleableSelectorValue)
      customTargets.forEach(target => {
        target.classList.toggle(this.toggleClass)
      })
    } else {
      this.toggleableTargets.forEach(target => {
        target.classList.toggle(this.toggleClass)
      })
    }
  }
}
